// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"1f6f3e16","268":"f38fd330","370":"52fe8be8","385":"a3593b66","436":"688d819e","766":"3985683b","926":"f6bd88ad"}[chunkId] + ".chunk.js";
};